import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IconContext } from "react-icons";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { formFields } from "../../../assets/data/survey/survey-form-field";
import { DashboardWrapper } from "../../../components/DashboardWrapper/DashboardWrapper.styles";
import {
    FormContainer,
    FormGroup,
    FormWrapper,
    Input,
    Label,
    Title,
} from "../../../components/PatientSurvey/PatientSurvey.styles";
import { getSurveysByPatientandSurveyId } from "../../../utils/api-lists/patient.api";
import { GeneralBody } from "../../../widgets/GeneralBody";
import { Header } from "../styles";

const PatientSurveyDetails = () => {
    const navigate = useNavigate();
    const { t } = useTranslation("common");
    const { patientId, surveyId } = useParams();

    const [survey, setSurvey] = useState(null);
    const [formattedResponse, setFormattedResponse] = useState(null);

    useEffect(() => {
        getSurveysByPatientandSurveyId(patientId, surveyId)
            .then((data) => {
                console.log('TTT data ', data);

                // the API sometimes returns the survey response as a string, sometimes as
                // an object and occasionally wrapped in a `response` field.  Normalize it so
                // we always end up with a plain object before trying to render it.
                let surveyResponse;
                let dataSurvey = data.survey_response ?? data;
                console.log('TTT dataSurvey ', dataSurvey);

                if (dataSurvey) {
                    if (typeof dataSurvey === 'string') {
                        try {
                            surveyResponse = JSON.parse(dataSurvey);
                        } catch (err) {
                            console.error('could not parse survey_response string', err);
                            surveyResponse = {};
                        }
                    } else if (
                        dataSurvey.response !== undefined &&
                        typeof dataSurvey.response === 'string'
                    ) {
                        try {
                            surveyResponse = JSON.parse(dataSurvey.response);
                        } catch (err) {
                            console.error('could not parse nested survey_response.response', err);
                            surveyResponse = {};
                        }
                    } else if (dataSurvey.response !== undefined) {
                        // already an object
                        surveyResponse = dataSurvey.response;
                    } else {
                        surveyResponse = dataSurvey;
                    }
                }

                setSurvey({
                    ...data,
                    survey_response: surveyResponse,
                });

                const formattedResponseTemp = surveyResponse
                    ? Object.entries(surveyResponse).map(([key, value]) => {
                        const field = formFields.find((f) => f.name === key);
                        const label = field ? field.label : key;
                        const formattedValue = Array.isArray(value)
                            ? value.join(', ')
                            : value;
                        return { label, value: formattedValue };
                    })
                    : null;

                setFormattedResponse(formattedResponseTemp);
                console.log('ttt', formattedResponseTemp);
            })
            .catch((error) => {
                console.error('failed to load survey details', error);
            });
    }, [patientId, surveyId]);

    // const surveyResponse = survey?.survey_response
    //     ? JSON.parse(survey.survey_response)
    //     : null;


    return (
        <DashboardWrapper>
            <Header>
                <IconContext.Provider value={{ style: { cursor: "pointer" } }}>
                    <FaArrowLeft onClick={() => navigate(-1)} />
                </IconContext.Provider>
                <h3>{t("survey_details")}</h3>
            </Header>
            <GeneralBody>
                <FormContainer>
                    <FormWrapper>
                        <Title>{t("glacies_biome_questionare_response")}</Title>

                        {formattedResponse && formattedResponse.map((field, index) => (
                            <FormGroup key={index}>
                                <Label>{t(field.label)}</Label>
                                <Input
                                    type="text"
                                    name={field.value}
                                    value={t(field.value)}
                                    disabled={true}
                                />
                            </FormGroup>
                        ))}
                        <FormGroup></FormGroup>
                    </FormWrapper>
                </FormContainer>
            </GeneralBody>
        </DashboardWrapper>
    );
};

export default PatientSurveyDetails;
